<div class="page-layout carded left-sidenav toolbar-fixed-layout">
    <mat-sidenav-container>
        <!-- CENTER -->
        <div class="center flex flex-row" style="background: red">
            <!-- CONTENT CARD -->

            <div class="content-card mat-white-bg flex flex-col full-grow-no-shrink-no-basis">

                <div class="p-lr-30">
                    <h1 class="m-t-30">Withholding Tax Forms </h1>
                    <div class="note">
                        <div>Please <a (click)='goWhtFormPage()'>click here</a> to view original language and English
                            versions of
                            forms required by countries for income recipients to establish
                            tax residency to claim treaty benefits and forms required to claim any withholding tax rate
                            reductions
                            provided for by an applicable treaty
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </mat-sidenav-container>
</div>
